module.exports = __webpack_public_path__ + "assets/img/DATOSPERSONALES_1.07760a9a.svg";